import * as React from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { Store } from 'redux'
import { History } from 'history'
import { ThemeProvider } from '@material-ui/core/styles'

import { SnackbarProvider } from 'notistack'
import { Notifier } from 'components/common/notification/Notifier'
import Routes from './routes'
import { ApplicationState } from './store'
import * as themes from './styles/theme'

// Any additional component props go here.
interface MainProps {
  store: Store<ApplicationState>
  history: History
}

// Create an intersection type of the component props and our Redux props.
const Main: React.FC<MainProps> = ({ store, history }) => {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <ThemeProvider theme={themes.light}>
          <SnackbarProvider>
            <Notifier />
            <Routes />
          </SnackbarProvider>
        </ThemeProvider>
      </ConnectedRouter>
    </Provider>
  )
}

// Normally you wouldn't need any generics here (since types infer from the passed functions).
// But since we pass some props from the `index.js` file, we have to include them.
// For an example of a `connect` function without generics, see `./containers/LayoutContainer`.
export default Main
